import { AppService } from './../../../core/app.service';
import { ActivtieResponse } from './../../../data/http/responses/activite.response';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { routeAlias } from "../../../../routesalias";
import { ReportService } from "../../../services/report.service";
import { createActivite, IActivite } from "../model/IActivite";
import { ActiviteForReportService } from "../../../services/activiteForReportService";
import { TypeInterventionService } from "../../../services/typeintervention/typeintervention.service";
import { ParametrageStructureProgrammatiqueService } from '../../../services/typeintervention/parametragestructureprogrammatique.service';
import { ParametrageStructureProgrammatiqueResponse } from '../../../data/http/responses/parametragestructureprogrammatique.response';
//import { ActivtieResponse } from "../../../data/http/responses/activite.response";
import { TypeInterventionResponse } from "../../../data/http/responses/typeintervention.response";
import { MatIcon } from "@angular/material/icon";
import { TypeActiviteResponse } from '../../../data/http/responses/typeactivite.response';
import { TypeActiviteService } from '../../../services/typeactivites/typeactivite.service';
import { OngletlayoutComponent } from '../../../components/layouts/ongletlayout/ongletlayout.component';
import { NgIf } from '@angular/common';
import { closeLocalStorage } from '../../../utils/helpers';
import { UiButtonComponent } from '../../../components/button/button.component';
@Component({
  templateUrl: "./activities.component.html",
  styleUrl: "./activities.component.css",
  selector: "app-activities-page",
  imports: [
    RouterOutlet,
    MatIcon,
    OngletlayoutComponent,
    //UiTable,
    NgIf,
    UiButtonComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})



export class ActivityPage implements OnInit {

  private readonly ptaYear = 2026;

  constructor(
    private reportService: ReportService,
    private structureProgrammatiqueService: ActiviteForReportService,
    private typeInterventionService: TypeInterventionService,
    private parametrageStructureProgrammatiqueService: ParametrageStructureProgrammatiqueService,
    private typeActiviteService: TypeActiviteService,
    private router: Router,
    private route: ActivatedRoute,
    private AppService: AppService
  ) { }
  public data: any[] = []

  public typeactivities: TypeActiviteResponse[] = [];
  public structures: ActivtieResponse[] = [];
  public activites: ActivtieResponse[] = [];
  public typeInterventionData: TypeInterventionResponse[] = [];
  public taches: any[] | null = null;
  /** ID of the intervention type where sub-activities begin. */
  public configuredActivityTypeId: string | null = null;
  

  // BREAKPOINT ICI
  ngOnInit(): void {
    this.loadTypeIntervention();
    this.loadStructureConfiguration();
    this.loadTypeActivite();
  }

  private loadStructureConfiguration(): void {
    this.parametrageStructureProgrammatiqueService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        const configurations = (response.data || []) as ParametrageStructureProgrammatiqueResponse[];
        this.configuredActivityTypeId = configurations.find(
          configuration => configuration.reference === 'STRUCTURE_PROGRAMMATIQUE'
        )?.valeur || null;
        
        this.loadStructures();
      },
      error: (error) => {
        console.error('Erreur lors du chargement de la configuration de la structure programmatique :', error);
        this.configuredActivityTypeId = null;  
        this.loadStructures();
      }
    });
  }

  hasAccess(roles?: string[]): boolean {
    if (!roles || roles.length === 0) return true;
    // Utilise le même service que la sidebar
    if (this.AppService['authService'] && typeof this.AppService['authService'].hasAnyRole === 'function') {
      const result = this.AppService['authService'].hasAnyRole(roles);
      try {
        //console.debug('ExpressionBesoin.hasAccess check', { required: roles, userRoles: this.AppService['authService'].getUserRoles(), allowed: result });
      } catch (e) { }
      return result;
    }
    return false;
  }

  loadStructures(): void {
    this.structureProgrammatiqueService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.activites = response.data;
        //console.log("Activites : " + this.activites)
        this.structures = [];

        this.activites.forEach((activite) => {
          if (activite.typeActivite === "PROGRAMMES" || activite.typeActivite === "PROGRAMME") {
            this.structures.push(activite);
          }
        });

        // //console.log("Structure : " + this.structures)
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  loadTypeIntervention(): void {
    this.typeInterventionService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.typeInterventionData = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  onClickMenu(): void {
    closeLocalStorage();
  }


  tableLinkForActivities = [
    {
      link: routeAlias.activities.structuresprogrammatiques.home,
      text: "Structure programmatiques"
    },
    {
      link: routeAlias.activities.activity.home,
      text: "Activités"
    },
  ]


  loadTypeActivite(): void {
    this.typeActiviteService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.typeactivities = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }


  findTaches(act: ActivtieResponse): any[] {
    let type: string = '';
    act.caracteristiques?.forEach((caract) => {
      if ("TYPE_ACTIVITE".toUpperCase() === caract.code) {
        type = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }
    });

    const foundTypeActivity = this.typeactivities.find(typeActivity => typeActivity.type_activite === type);
    if (foundTypeActivity) {
      return foundTypeActivity.taches;
    } else {
      return [];
    }
  }



  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  telechargerRapportPtaXlsx() {
    this.telechargerRapportPta("xlsx");
  }
  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  telechargerRapportPta(format = 'pdf') {
    this.structureProgrammatiqueService.getFullTree(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        const fullTree: ActivtieResponse[] = response.data;
        const programmes = fullTree.filter((activite: ActivtieResponse) =>
          activite.typeActivite === "PROGRAMMES" || activite.typeActivite === "PROGRAMME"
        );
        this.genererRapportPta(programmes, format);
      },
      error: (error) => {
        console.error('Erreur lors du chargement de l\'arbre complet pour le rapport :', error);
      }
    });
  }

  // Gestion des etat 
  /* --- Fonctions de génération de rapports --- */
  private buildDataFromHierarchy(node: ActivtieResponse, path: string[] = []): void {
    const ref = path.join('.');
    if (ref) {
      this.toData(ref, node);
    }

    const children = node.taches ?? [];
    children.forEach((child, index) => {
      this.buildDataFromHierarchy(child, [...path, String(index + 1)]);
    });
  }

  private genererRapportPta(structures: ActivtieResponse[], format: string) {
    try {
      this.data = []
      let i: number = 0, j: number = 0, k: number = 0, l: number = 0, m: number = 0;

      structures.forEach((programme, index) => {
        this.buildDataFromHierarchy(programme, [String(index + 1)]);
      });

      const parameters = {
        NiveauStructProgrammatique: this.configuredActivityTypeId,
        annee: this.ptaYear,
        objectif_general: "Améliorer l'efficacité, la célérité, la qualité et l'accessibilité des prestations sociales au profit des assurés."
      };
      if (this.data.length === 0) return;
      const reportObservable = this.reportService.generatePtaReport(format, this.data, parameters);

      reportObservable.subscribe({
        next: (blob: Blob) => {
          if (format === 'pdf') {
            this.reportService.openOrDownloadReport(blob, `pta.pdf`);
          } else {
            this.reportService.downloadReport(blob, `pta.${format}`);
          }
        },
        error: (err: any) => console.error('Erreur téléchargement :', err)
      });

    } catch (error) {
      console.error('Erreur lors du téléchargement du rapport:', error)
    }
  }

  private getMonthFlags(dateDebut: unknown, dateFin: unknown, targetYear: number): Pick<IActivite,
    'janvier' | 'fevrier' | 'mars' | 'avril' | 'mai' | 'juin' | 'juillet' | 'aout' |
    'septembre' | 'octobre' | 'novembre' | 'decembre'> {
    const monthNames = [
      'janvier', 'fevrier', 'mars', 'avril', 'mai', 'juin',
      'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'decembre'
    ] as const;
    const monthFlags = Object.fromEntries(monthNames.map(month => [month, false])) as Pick<IActivite,
      typeof monthNames[number]>;
    const startDate = this.parseActivityDate(dateDebut);
    const endDate = this.parseActivityDate(dateFin);

    if (!startDate || !endDate || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return monthFlags;
    }

    const firstDate = startDate <= endDate ? startDate : endDate;
    const lastDate = startDate <= endDate ? endDate : startDate;
    const firstYear = firstDate.getFullYear();
    const lastYear = lastDate.getFullYear();

    if (lastYear < targetYear || firstYear > targetYear) {
      return monthFlags;
    }

    const firstMonth = firstYear === targetYear ? firstDate.getMonth() : 0;
    const lastMonth = lastYear === targetYear ? lastDate.getMonth() : 11;

    monthNames.forEach((month, monthIndex) => {
      monthFlags[month] = firstMonth <= monthIndex && monthIndex <= lastMonth;
    });

    return monthFlags;
  }

  private parseActivityDate(value: unknown): Date | null {
    if (!value) return null;
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : new Date(value.getTime());
    }

    if (Array.isArray(value) && value.length >= 3) {
      const [year, month, day] = value.map(Number);
      const parsedDate = new Date(year, month - 1, day);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    if (typeof value === 'object') {
      const dateValue = value as { year?: unknown; month?: unknown; day?: unknown };
      if (dateValue.year !== undefined && dateValue.month !== undefined && dateValue.day !== undefined) {
        const parsedDate = new Date(
          Number(dateValue.year),
          Number(dateValue.month) - 1,
          Number(dateValue.day)
        );
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }
      return null;
    }

    if (typeof value === 'string') {
      const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
      if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch;
        const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }
    }

    const parsedDate = new Date(value as string | number);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  private getMonthFlagsForNode(
    typeActivite: string | undefined,
    dateDebut: unknown,
    dateFin: unknown,
    targetYear: number
  ): Pick<IActivite,
    'janvier' | 'fevrier' | 'mars' | 'avril' | 'mai' | 'juin' | 'juillet' | 'aout' |
    'septembre' | 'octobre' | 'novembre' | 'decembre'> {
    const activityType = this.typeInterventionData.find(type => type.id === typeActivite);
    const configuredType = this.typeInterventionData.find(
      type => type.id === this.configuredActivityTypeId
    );

    if (activityType && configuredType && activityType.niveau < configuredType.niveau) {
      return this.getMonthFlags(null, null, targetYear);
    }

    return this.getMonthFlags(dateDebut, dateFin, targetYear);
  }


  toData(ref: string, act: ActivtieResponse) {

    //console.log(" activite : " + act)
    let imput_budget: number = 0;
    let montant_estim: number = 0;
    let produit: number = 0;
    let cout_prev: number = 0;
    let montant_dec: number = 0;
    let prev_dec: number = 0;
    let horizon: string = '';
    let coup_prev: number = 0;
    let poids: number = 0;
    let struc_res: string = '';
    let struc_asso: string = '';
    let superv: string = '';
    let mode_exec: string = '';
    let observation: string = '';
    let prev_dec_27: number = 0;
    let prev_dec_N2: number = 0;
    let prev_dec_N3: number = 0;

    act.caracteristiques?.forEach((caract) => {
      if ("SUPERVISOR".toUpperCase() === caract.code) {
        superv = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MODEEXECUTION".toUpperCase() === caract.code || "MODE_EXECUTION".toUpperCase() === caract.code) {
        mode_exec = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("STRUCTASSOCIE".toUpperCase() === caract.code) {
        struc_asso = struc_asso === '' ? caract.valeur : struc_asso + ', ' + caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("STRUCTURERESPONSABLE".toUpperCase() === caract.code || "STRUCTURE_RESPONSABLE".toUpperCase() === caract.code) {
        struc_res = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MONTANT_ESTIMATIF".toUpperCase() === caract.code || "DECAISSEMENT_ESTIMATIF" === caract.code) {
        montant_estim = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }  else if ("ENCAISSEMENT_ESTIMATIF" === caract.code) {
        produit = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("IMPUTATIONBUDGETAIRE".toUpperCase() === caract.code || "IMPUTATION_BUDGETAIRE".toUpperCase() === caract.code) {
        imput_budget = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("HORIZON".toUpperCase() === caract.code) {
        horizon = caract.valeur;
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("COUTPREVU2025".toUpperCase() === caract.code || "COUT_PREVU_N".toUpperCase() === caract.code) {
        cout_prev = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("COUTPREVU2026".toUpperCase() === caract.code || "COUT_PREVU_N1".toUpperCase() === caract.code) {
        coup_prev = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("PREVISIONDECAISSEMENTT4_2025" === caract.code || "PREVISION_DECAISSEMENT_T4_N" === caract.code) {
        prev_dec = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("PREVISIONDECAISSEMENT2027" === caract.code || "PREVISION_DECAISSEMENT_N1" === caract.code) {
        prev_dec_27 = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      } else if ("MONTANTDECAISSEAU30SEPT2025".toUpperCase() === caract.code || "PREVISION_DECAISSEMENT_T3_N" === caract.code) {
        montant_dec = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);

      } else if ("POIDS".toUpperCase() === caract.code) {
        poids = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }
      else if ("PREVISION_DECAISSEMENT_N2".toUpperCase() === caract.code) {
        prev_dec_N2 = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }
      else if ("PREVISION_DECAISSEMENT_N3".toUpperCase() === caract.code) {
        prev_dec_N3 = isNaN(Number(caract.valeur)) ? 0 : Number(caract.valeur);
        //console.log("code : " + caract.code + " valeur : " + caract.valeur);
      }

    });

    

    //console.log(" type : " + act.typeActivite)
    const activite: IActivite = {
      type: act.typeActivite,
      num: ref,
      objectifs: act.titre,
      imput_budget: imput_budget,
      montant_estim: montant_estim,
      cout_prev: cout_prev,
      montant_dec: montant_dec,
      prev_dec: prev_dec,
      horizon: horizon,
      coup_prev: coup_prev,
      poids: poids,
      struc_res: struc_res,
      struc_asso: struc_asso,
      superv: superv,
      mode_exec: mode_exec,
      observation: observation,
      prev_dec_27: prev_dec_27,
      prev_dec_N3: prev_dec_N3,
      prev_dec_N2: prev_dec_N2,
      produit: produit,
      date_debut: act.dateDebut ? new Date(act.dateDebut) : null,
      date_fin: act.dateFin ? new Date(act.dateFin) : null,
      ...this.getMonthFlagsForNode(act.typeActivite, act.dateDebut, act.dateFin, this.ptaYear),

    };
    this.data.push({ ...activite });
  }

  toTacheData(ref: string, act: any) {

    //console.log(" tache : " + act)
    //console.log(" type : " + act.typeActivite)
    //console.log(" tache : " + act.tache)
    const activite: IActivite = createActivite({
      type: "TACHE",
      num: ref,
      objectifs: act.tache,
      poids: act.poids,
      date_debut: act.dateDebut ? new Date(act.dateDebut) : null,
      date_fin: act.dateFin ? new Date(act.dateFin) : null,
      ...this.getMonthFlagsForNode(act.typeActivite, act.dateDebut, act.dateFin, this.ptaYear),
    });

    this.data.push({ ...activite });
  }


}